import { render, staticRenderFns } from "./ResetCachesModal.vue?vue&type=template&id=01f58cc5&scoped=true&"
import script from "./ResetCachesModal.vue?vue&type=script&lang=js&"
export * from "./ResetCachesModal.vue?vue&type=script&lang=js&"
import style0 from "./ResetCachesModal.vue?vue&type=style&index=0&id=01f58cc5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01f58cc5",
  null
  
)

export default component.exports